import React from 'react';
import InputMask from 'react-input-mask';
import {
  Container,
  Description,
  Formulario,
  ImageCustom,
  Layout,
  Title,
} from './style';
import api from '../../services/api';
import { withRouter } from 'react-router-dom';
import { login } from '../../services/auth';
import ErrorModal from '../../components/ErrorModal';
import './styles/login.css';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      session: '',
      token: '',
      qrCode: '',
      openBackdrop: false,
      openMenuModal: false,
      openErrorModal: false,
      errorMessage: '',
      titleError: '',
    };

    this.animationRef = React.createRef();
  }

  submitSession = async (e) => {
    e.preventDefault();
    if (this.state.session === '') {
      this.handleOpenErrorModal();
      this.setState({
        titleError: 'Preencha todos os campos',
        errorMessage:
          'Você precisa preencher todos os campos antes de continuar.',
      });
    } else {
      this.handleToggleBackdrop();

      try {
        const response = await api.post('/auth/login', null, {
          params: {
            username: this.state.session,
            password: this.state.token,
          },
        });
        console.log(response);
        login(JSON.stringify(response.data));
        this.props.history.push('/painel');
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Erro de autenticação (não autorizado)
          this.setState({
            titleError: 'Erro de Autenticação',
            errorMessage: 'Nome de usuário ou senha inválidos.',
          });
          this.handleOpenErrorModal();
        } else {
          // Outros erros de rede
          this.setState({
            titleError: 'Erro de Conexão',
            errorMessage:
              'Ocorreu um erro ao tentar se conectar com o servidor.',
          });
          this.handleOpenErrorModal();
        }
      }
    }
  };

  handleToggleBackdrop = () => {
    this.setState((prevState) => ({ openBackdrop: !prevState.openBackdrop }));
  };
  handleCloseErrorModal = () => {
    this.setState({ openErrorModal: false });
  };

  handleOpenErrorModal = () => {
    this.setState({ openErrorModal: true });
  };

  render() {
    const { open, qrCode, session, token } = this.state;
    let mask;
    let match = session.match(/\d+/g);

    if (match != null && match.join('').length > 11) {
      mask = '99.999.999/9999-99';
    } else {
      mask = '999.999.999-99';
    }
    console.log('titleError');
    return (
      <div>
        <ErrorModal
          handleClose={this.handleCloseErrorModal}
          open={this.state.openErrorModal}
          errorMessage={this.state.errorMessage}
          titleError={this.state.titleError}
        />

        <Container>
          <div className={'container-session'} id='login-full-div'>
            {/* <div id={'left-div'}> */}
            {/*<img src={LoginImage} alt={"Login Team"} />*/}
            {/* </div> */}

            <div className="login-div">
              {qrCode === '' ? null : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <ImageCustom
                    ref={this.animationRef}
                    className={'animation noselect'}
                    autoplay
                    src={qrCode}
                    alt={'Smartphone'}
                    draggable={'false'}
                  />
                  <Title>Scan QRCode</Title>
                </div>
              )}

              {qrCode !== '' ? null : (
                <Formulario onSubmit={this.submitSession}>
                  <div className="logo-sasc-cm"></div>

                  <Description id={'description'}>
                    Entre com suas credenciais
                  </Description>

                  <div className={'top-info'}>
                    <small>CPF</small>
                  </div>
                  <InputMask
                    mask={mask}
                    id={'session'}
                    autoComplete="off"
                    placeholder="CPF"
                    value={session}
                    onChange={(e) => this.setState({ session: e.target.value })}
                  />

                  <div className={'top-info'}>
                    <small>SENHA</small>
                  </div>

                  <input
                    id={'token'}
                    autoComplete="off"
                    placeholder="Senha"
                    type={'password'}
                    value={token}
                    onChange={(e) => this.setState({ token: e.target.value })}
                  />

                  <button type="submit" id="send-btn">
                    Enviar
                  </button>
                </Formulario>
              )}
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(LoginPage);
